<template>
  <!-- <keep-alive> -->
  <router-view :key="$pageComponentNextKey" />
  <!-- </keep-alive> -->
</template>

<script>
import pageComponent from '@/mixins/page-component';

export default {
  name: 'AbstractRoute',
  mixins: [pageComponent],
  props: {
    store: { type: Object, required: true },
  },
  created() {
    if (this.store) {
      const { namespace } = this.store;
      this.$store.registerModule(namespace.split('/'), { namespaced: true });
    }
  },
  destroyed() {
    if (this.store) {
      const { namespace } = this.store;
      this.$store.unregisterModule(namespace.split('/'));
    }
  },
};
</script>
